import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '@infra/auth/auth.service';

@Component({
  selector: 'app-resource-planning-nav-bar',
  templateUrl: './resource-planning-nav-bar.component.html',
  imports: [TranslatePipe, RouterModule],
})
export class ResourcePlanningNavBarComponent {
  readonly authService = inject(AuthService);
}
